export default "__VITE_ASSET__CH97vxTq__"